import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";

const CreateDirections = () => {
  return (
    <Create title="Създаване на направление">
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateDirections;